const sandSystem = {
  emitters: [
    {
      id: 1,
      layer: {
        type: 'string',
        value: 'foreground',
      },
      position: {
        type: 'vectorRange',
        value: [
          [-0.1, 0.98],
          [1, 1],
        ],
      },
      angle: {
        type: 'range',
        value: [0, 0],
      },
      speed: {
        type: 'range',
        value: [3, 6],
      },
      rate: {
        type: 'float',
        value: 1,
      },
      particle: {
        lifetime: {
          type: 'range',
          value: [0.75, 2],
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0,
        },
        scale: {
          type: 'range',
          value: [1, 2],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'fade',
        },
        drag: {
          type: 'vectorRange',
          value: [
            [2, 2],
            [4, 4],
          ],
        },
        color: {
          type: 'colorOverLife',
          color: '#b08d60',
          value: [
            {
              keyframe: 0,
              value: [176, 141, 96, 0],
            },
            {
              keyframe: 5,
              value: [176, 141, 96, 0.6],
            },
            {
              keyframe: 90,
              value: [176, 141, 96, 0.6],
            },
            {
              keyframe: 100,
              value: [176, 141, 96, 0],
            },
          ],
        },
      },
    },
    {
      id: 10,
      layer: {
        type: 'string',
        value: 'foreground',
      },
      position: {
        type: 'vectorRange',
        value: [
          [-0.1, 0.98],
          [1, 1],
        ],
      },
      angle: {
        type: 'range',
        value: [0, 0],
      },
      speed: {
        type: 'range',
        value: [-6, -3],
      },
      rate: {
        type: 'float',
        value: 1,
      },
      particle: {
        lifetime: {
          type: 'range',
          value: [0.75, 2],
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0,
        },
        scale: {
          type: 'range',
          value: [1, 2],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'fade',
        },
        drag: {
          type: 'vectorRange',
          value: [
            [2, 2],
            [4, 4],
          ],
        },
        color: {
          type: 'colorOverLife',
          color: '#b08d60',
          value: [
            {
              keyframe: 0,
              value: [176, 141, 96, 0],
            },
            {
              keyframe: 5,
              value: [176, 141, 96, 0.6],
            },
            {
              keyframe: 90,
              value: [176, 141, 96, 0.6],
            },
            {
              keyframe: 100,
              value: [176, 141, 96, 0],
            },
          ],
        },
      },
    },

    {
      id: 3,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [-0.1, 1.25],
          [1.2, 1.25],
        ],
      },
      angle: {
        type: 'float',
        value: -3.14,
      },
      speed: {
        type: 'float',
        value: 0.1,
      },
      rate: {
        type: 'float',
        value: 11,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 6,
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0.0005,
        },
        scale: {
          type: 'range',
          value: [40, 60],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          color: '#ab926b',
          value: [
            {
              keyframe: 0,
              value: [171, 146, 107, 0],
            },
            {
              keyframe: 40,
              value: [171, 146, 107, 0.05],
            },
            {
              keyframe: 60,
              value: [171, 146, 107, 0.05],
            },
            {
              keyframe: 100,
              value: [171, 146, 107, 0],
            },
          ],
        },
      },
    },
    {
      id: 6,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0, 0.2],
          [1.2, 1.2],
        ],
      },
      angle: {
        type: 'float',
        value: -3.14,
      },
      speed: {
        type: 'float',
        value: 0.1,
      },
      rate: {
        type: 'float',
        value: 11,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 6,
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0.0005,
        },
        scale: {
          type: 'range',
          value: [20, 200],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          value: [
            {
              keyframe: 0,
              value: [176, 141, 96, 0],
            },
            {
              keyframe: 20,
              value: [176, 141, 96, 0.002],
            },
            {
              keyframe: 40,
              value: [176, 141, 96, 0.002],
            },
            {
              keyframe: 100,
              value: [176, 141, 96, 0],
            },
          ],
        },
      },
    },
  ],
  effects: [
    {
      type: 'gravity',
      emitters: [1, 10],
      energy: 'above',
      data: {
        position: [0.5, 0.1],
        radius: 0.4,
        amount: 0.02,
      },
    },
    {
      type: 'gravity',
      emitters: [1, 10],
      energy: 'above',
      data: {
        position: [0.5, 1.5],
        radius: 0.6,
        amount: -0.001,
      },
    },
    {
      type: 'gravity',
      emitters: [1, 10],
      energy: 'above',
      data: {
        position: [0.85, 0.1],
        radius: 0.6,
        amount: 0,
      },
    },
    {
      type: 'impulse',
      emitters: [1, 10],
      energy: 'above',
      data: {
        direction: 0,
        amount: 0.2,
      },
    },
    {
      type: 'impulse',
      emitters: [1, 10],
      energy: 'above',
      data: {
        direction: -1.57,
        amount: 0.06,
      },
    },
  ],
}

export default sandSystem
